import { Controller } from "@hotwired/stimulus"
import { NativeBridge } from "../lib/native_bridge"

// Connects to data-controller="notification-auto-read"
// Single responsibility: Auto-mark notifications as read on first click
// Used on notification tab button in profile page
export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this._called = false
    console.debug("[notification-auto-read] connected", this.urlValue)
  }

  async markAsRead() {
    // No endpoint configured
    if (!this.hasUrlValue || !this.urlValue) return

    // Skip if already called
    if (this._called) return

    const tabBadge = document.getElementById("unread_count")
    const navBadge = document.getElementById("notification_badge")

    this._called = true
    console.debug("[notification-auto-read] markAsRead start", this.urlValue)

    // Optimistic UI update: hide badges immediately
    this.clearBadges(tabBadge, navBadge)

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      if (!csrfToken) return

      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": csrfToken
        }
      })

      if (response.ok) {
        const text = await response.text()
        // Use global Turbo from @hotwired/turbo-rails (consistent with gps_controller, chat_swipe_controller)
        Turbo.renderStreamMessage(text)
      } else {
        // Allow retry on non-OK responses
        this._called = false
        if (response.status === 429) {
          console.warn("[notification-auto-read] Rate limited, will retry on next click")
        }
        console.warn("[notification-auto-read] Request failed with status", response.status)
      }
    } catch (error) {
      // Network error - allow retry
      this._called = false
      console.warn("[notification-auto-read] Network error:", error.message)
    }
  }

  clearBadges(tabBadge, navBadge) {
    if (tabBadge) {
      tabBadge.classList.add("hidden")
      tabBadge.textContent = ""
    }

    if (navBadge) {
      navBadge.textContent = ""
      navBadge.classList.add("hidden")
      navBadge.setAttribute("aria-label", "")
    }

    // Clear native tab bar badge (optimistic — server confirms via badge:update)
    if (NativeBridge.isNative()) {
      NativeBridge.TabBadge.clear("profile", true)
    }
  }

}
